// Mock data for Leonia Farmhouse Landing Page

export const farmhouseData = {
  hero: {
    title: "Leoland by VengaFarms",
    subtitle: "4 BHK Paradise with Private Pool at Leonia Resorts",
    location: "Shamirpet, Hyderabad",
    heroImage: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/t2n9u7aj_IMG_7240.jpeg"
  },
  
  pricing: {
    weekday: 12000,
    saturday: 15000,
    maxGuests: 12,
    checkIn: "3:00 PM",
    checkOut: "11:00 AM"
  },
  
  amenities: [
    {
      icon: "Home",
      title: "4 Spacious Bedrooms",
      description: "Fully air-conditioned bedrooms with comfortable bedding for 12 guests"
    },
    {
      icon: "Waves",
      title: "Private Pool",
      description: "Exclusive swimming pool for your group with pool loungers"
    },
    {
      icon: "Trees",
      title: "Private Garden",
      description: "Lush green garden space perfect for outdoor activities"
    },
    {
      icon: "Sofa",
      title: "Spacious Hall",
      description: "Large air-conditioned hall for gatherings and entertainment"
    },
    {
      icon: "ChefHat",
      title: "Kitchenette",
      description: "Well-equipped kitchenette for preparing light meals"
    },
    {
      icon: "Music",
      title: "Speaker System",
      description: "Premium sound system for your parties and gatherings"
    },
    {
      icon: "Flame",
      title: "BBQ & Bonfire",
      description: "Outdoor BBQ grill and bonfire pit \u2014 \u20b91,000 each, on request"
    },
    {
      icon: "UserCheck",
      title: "Full-time Caretaker",
      description: "Dedicated caretaker available throughout your stay"
    },
    {
      icon: "Shield",
      title: "Safe & Secure",
      description: "Located within Leonia Resorts boundaries with 24/7 security"
    },
    {
      icon: "Wifi",
      title: "High-Speed WiFi",
      description: "Stay connected with reliable internet throughout the property"
    }
  ],
  
  gallery: [
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/1ouvu168_IMG_7239.jpeg",
      title: "Private Pool & Container House",
      category: "Pool"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/1fon4uie_IMG_7232.jpeg",
      title: "Elegant Living Room",
      category: "Interior"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/mayum0bk_IMG_7233.jpeg",
      title: "Dining Area",
      category: "Interior"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/5zvt4asl_IMG_7238.jpeg",
      title: "Outdoor Terrace Seating",
      category: "Outdoor"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/fcdsdcj4_IMG_7241.jpeg",
      title: "Garden with Loungers",
      category: "Garden"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/db0yaxwa_IMG_7244.jpeg",
      title: "Master Bedroom",
      category: "Bedroom"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/hnbj15nf_IMG_7242.jpeg",
      title: "Cozy Bedroom",
      category: "Bedroom"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/jfysysvp_IMG_7248.jpeg",
      title: "Spacious Garden",
      category: "Garden"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/hkqlimvm_IMG_7251.jpeg",
      title: "Daytime Exterior View",
      category: "Exterior"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/ljrn4h3b_IMG_7246.jpeg",
      title: "Beautiful Garden Lighting",
      category: "Garden"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/6g1gxtrn_IMG_7247.jpeg",
      title: "Rooftop Terrace",
      category: "Outdoor"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_leonia-farmhouse/artifacts/3bch4j42_IMG_7252.jpeg",
      title: "Container Architecture",
      category: "Exterior"
    }
  ],
  
  testimonials: [
    {
      name: "Rahul & Family",
      rating: 5,
      date: "December 2024",
      text: "Absolutely loved our stay at this beautiful farmhouse! The black container design is stunning and the pool was perfect for the kids. The caretaker was very helpful and the location inside Leonia Resorts made us feel completely safe.",
      avatar: "R"
    },
    {
      name: "Priya Sharma",
      rating: 5,
      date: "November 2024",
      text: "Perfect venue for our family reunion! We were 10 people and had plenty of space. The bonfire night was magical and the BBQ setup was excellent. Highly recommend for group gatherings!",
      avatar: "P"
    },
    {
      name: "Aditya & Friends",
      rating: 5,
      date: "October 2024",
      text: "Great place for a weekend getaway with friends! The pool parties were amazing, the sound system was fantastic, and we loved the modern interiors. Will definitely book again!",
      avatar: "A"
    }
  ],
  
  houseRules: [
    "Maximum 12 guests allowed",
    "No smoking inside the farmhouse",
    "Pets are not allowed",
    "No loud music after 11 PM",
    "Pool usage at your own risk - children must be supervised",
    "Please maintain cleanliness throughout your stay",
    "Bonfire and BBQ available on request \u2014 \u20b91,000 each",
    "Early check-in/late check-out subject to availability",
    "Free WiFi throughout \u2014 the caretaker shares the password at check-in",
    "For any assistance, contact caretaker Sriniwas: +91 70323 67209"
  ],
  
  faqs: [
    {
      question: "How do I reach the farmhouse?",
      answer: "IMPORTANT: The property is inside Leonia Resorts at Plot No. 429, just 5 minutes from Shamirpet ORR exit. First navigate to Leonia Resorts (https://maps.app.goo.gl/2cyALjV7hGkBz4eK6). After entering the resort gate, inform security you're going to Plot No. 429, then use the Venga Farms location (https://maps.app.goo.gl/rajmktUK2mkXVHEq8). Our caretaker Sriniwas (+91 70323 67209) will guide you from the gate."
    },
    {
      question: "What food and dining options are available?",
      answer: "You have multiple options: (1) Food court and restaurants inside Leonia Resorts - just a short walk away, (2) Swiggy and Zomato delivery works perfectly with lots of restaurant and dhaba options, (3) Use the kitchenette for light meals and snacks. You'll never run out of food choices!"
    },
    {
      question: "Is there WiFi at the farmhouse?",
      answer: "Yes \u2014 free WiFi covers the whole property and the connection is stable indoors and out on the deck. Our caretaker Sriniwas will give you the network name and password when you check in."
    },
    {
      question: "Who is the caretaker and how can I reach them?",
      answer: "Our caretaker Sriniwas is available full-time during your stay. You can reach him at +91 70323 67209 for any assistance, guidance, or requests."
    },
    {
      question: "What activities are nearby?",
      answer: "District Gravity is just a 2-minute walk from the farm with 150+ activities including adventure sports, games, and entertainment! Plus, you have full access to Leonia Resorts' facilities."
    },
    {
      question: "Is the property safe and secure?",
      answer: "Absolutely! The farm is inside Leonia Resorts boundaries with 24/7 security. You can enjoy complete peace of mind knowing the property is in a secure, gated resort environment."
    },
    {
      question: "Is the property suitable for children?",
      answer: "Yes, absolutely! The property is family-friendly with a private pool and garden. Children must be supervised at all times, especially around the pool. The property is completely safe within Leonia Resorts' secured boundaries with 24/7 security."
    },
    {
      question: "What cooking facilities are available?",
      answer: "The farmhouse has a kitchenette with basic cooking facilities for light meals. However, you don't need to cook! Leonia Resorts has food courts and restaurants, plus Swiggy/Zomato delivery works great with many restaurant and dhaba options available."
    },
    {
      question: "Can we have a bonfire and BBQ?",
      answer: "Yes \u2014 both are available at \u20b91,000 each, and that includes the charcoal and basic supplies. Let the caretaker Sriniwas know in advance so it is set up and lit when you want it."
    },
    {
      question: "What is the cancellation policy?",
      answer: "We take direct bookings only. Message or call us on +91 80080 02388 and we will confirm the cancellation terms in writing along with your dates."
    },
    {
      question: "Are pets allowed?",
      answer: "Unfortunately, pets are not allowed at the property to maintain hygiene standards for all guests."
    },
    {
      question: "Is parking available?",
      answer: "Yes, there is ample parking space available within the property premises for multiple vehicles."
    },
    {
      question: "How much does it cost to rent the farmhouse for a day?",
      answer: "₹12,000 for a weekday night (Sunday to Friday) and ₹15,000 on a Saturday. That is for the whole property \u2014 all four bedrooms, the private pool, the garden and the deck \u2014 for up to 12 guests, with no per-head charge. Bonfire and BBQ are ₹1,000 each if you want them."
    },
    {
      question: "How far is the farmhouse from Hyderabad?",
      answer: "About forty minutes from the city and only five minutes from the Shamirpet exit of the Outer Ring Road, which makes it one of the closer farmhouse stays to Hyderabad. The last stretch is inside Leonia Resorts, so it is a sealed road right up to the gate."
    },
    {
      question: "Is the swimming pool private to our group?",
      answer: "Yes. The pool sits inside the farmhouse's own walled garden and is used only by your group for the length of your stay \u2014 it is not shared with the resort or with other guests."
    },
    {
      question: "Can we host a birthday or a small get-together here?",
      answer: "Yes, and it is what most of our guests book it for. The house is set up for up to 12 guests with a large air-conditioned hall, a sound system, the pool and the garden. Music needs to go off by 11 PM under the resort's rules. If you are planning something larger than 12 people, message us on +91 80080 02388 first so we can tell you what is workable."
    },
    {
      question: "What are the check-in and check-out times?",
      answer: "Check-in is from 3:00 PM and check-out is 11:00 AM. Early check-in and late check-out are sometimes possible depending on whether the house is booked either side of you \u2014 just ask when you book."
    },
    {
      question: "How do I book the farmhouse?",
      answer: "We take direct bookings only, which keeps the price lower than the listing sites. Call or WhatsApp us on +91 80080 02388 with your dates, check the availability calendar on this page first, and we will confirm in writing."
    }
  ],
  
  location: {
    address: "Plot No. 429, Leonia Resorts, Shamirpet, Hyderabad - 500078",
    leoniaResortsMapUrl: "https://maps.app.goo.gl/2cyALjV7hGkBz4eK6?g_st=ic",
    vengaFarmsMapUrl: "https://maps.app.goo.gl/rajmktUK2mkXVHEq8?g_st=ic",
    directions: "IMPORTANT: First navigate to Leonia Resorts. After entering the resort, then open the Venga Farms location. Opening farm location directly will take you to the back gate!",
    gateEntry: "For gate entry, inform security: Plot No. 429",
    accessibility: "Just 5 minutes from Shamirpet ORR exit - Easy highway access!",
    safety: "Completely safe inside Leonia Resorts boundaries with 24/7 security",
    caretaker: {
      name: "Sriniwas",
      phone: "+917032367209"
    },
    wifi: {
      // Credentials are handed over by the caretaker at check-in — this page
      // is public and indexed by Google, so they do not belong here.
      note: "Free WiFi throughout; password shared at check-in"
    },
    nearbyAttractions: [
      "District Gravity - 2 min walk (150+ activities)",
      "Leonia Resorts Food Court & Restaurants - Walking distance",
      "Shamirpet Lake - 5 km",
      "Shamirpet ORR Exit - 5 minutes",
      "Hyderabad City Center - 30 km",
      "Rajiv Gandhi International Airport - 55 km"
    ],
    foodOptions: [
      "Leonia Resorts food court and restaurants (walking distance)",
      "Swiggy & Zomato delivery available",
      "Multiple restaurants and dhabas nearby",
      "Kitchenette for light meals"
    ]
  }
};
